// OperationLogUtil.ts

import { axiosRequest } from "../service/AxiosService";

/**
 * 操作ログを登録する処理
 * @param screenName 必須：画面名
 * @param operation 必須：操作内容
 * @param result 必須：操作結果
 * @param detail 任意：付加情報
 */
export const operationLog = async (
  screenName: String,
  operation: string,
  result: string,
  detail?: string
) => {
  try {
    //操作日付を取得
    const now = new Date();
    const formatted = now.toISOString(); // "2025-11-11T15:22:47.000Z"
    // パラメータの設定
    const options = {
      data: {
        date: formatted,
        screenName: screenName,
        operation: operation,
        result: result,
        detail: detail,
      },
    };
    // サーバー通信処理
    await axiosRequest<boolean>("/operationLog", "POST", options);
  } catch { }
};
